exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cms-card_section[data-v-44e0a336]{border:1px solid #e8e8e8;padding:15px}.cms-card_section--title[data-v-44e0a336]{margin:0;color:#0e4b88;font-size:21px;margin-bottom:15px}.cms-card_section+.cms-card_section[data-v-44e0a336]{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44e0a336","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cms/CMSCardSection.vue
// module id = gz1X
// module chunks = 0 1